import formatCurrency from "../../../utils/formatCurrency";

export default function ProductInfo({ product }) {
    return (
        <>
            <div class="flex-between flex-wrap gap-12 mb-20">
                <div>
                    <h3 class="mb-4">{product.name}</h3>
                    <p class="text-gray-600 text-15">{product.category?.name} / {product.subcategory?.name}</p>
                </div>
            </div>
            <span class="py-6 px-16 bg-main-50 text-main-600 rounded-pill text-15">Rp. {formatCurrency(parseInt(product.category_price) + parseInt(product.subcategory_price))}</span>
            <div class="flex-align gap-4 mt-4">
                {
                    product.rating > 0
                    &&
                    <>
                    <span class="text-15 fw-bold text-warning-600 d-flex"><i class="ph-fill ph-star"></i></span>
                    <span class="text-13 fw-bold text-gray-600">{product.rating}</span>
                    {/* <span class="text-13 fw-bold text-gray-300">(12k)</span> */}
                    </>
                }
                
            </div>

            <div class="mt-24">
                <div class="mb-24 pb-24 border-bottom border-gray-100">
                    <h5 class="mb-12 fw-bold">Description</h5>
                    <p class="text-gray-300 text-15">{product.description}</p>
                </div>
            </div>
        </>
    );
}
